// extracted by mini-css-extract-plugin
export default {"contentArea":"ContentArea_contentArea__S1Jxh"};